import React, { useRef } from 'react';
var VeltActivityLogHeaderFilterTriggerIcon = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-header-filter-trigger-icon", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltActivityLogHeaderFilterTriggerIcon;
